import * as types from './mutation-types';

export default {
  [types.SOCKET_ONOPEN](state, event) {
    if (state.debug) {
      console.log('Socket connected: ', event);
    }
    state.socket = event.currentTarget;
    state.readyState = state.socket.readyState;
  },

  [types.SOCKET_ONCLOSE](state, event) {
    if (state.debug) {
      console.log('Socket closed: ', event);
    }
    state.isConnected = false;
    state.readyState = state.socket.readyState;
    state.socket = null;
  },

  [types.SOCKET_ONMESSAGE](state, event) {
    if (state.debug) {
      console.log('Socket message: ', event);
    }
    const { data } = event;
    if (data == '1') {
      state.isConnected = true;
      return;
    }
    if (state.messageUpdateSuspended) {
      return;
    }
    let message;
    try {
      // `data` could be a simple code or stringified JSON
      message = JSON.parse(data);
      // `data` is not an Object ; Use `data` message type
      if (typeof message === 'number') {
        message = { msg: data };
      }
    } catch (e) {
      // `data` is a string ; Use `data` message type
      message = { msg: data };
    }
    state.message = message;
  },

  [types.SOCKET_NEWMESSAGE](state, newMessage) {
    state.newMessageAvailable = newMessage;
  },

  [types.SOCKET_ONERROR](state, event) {
    if (state.debug) {
      console.error('Socket error: ', event);
    }
    state.readyState = state.socket.readyState;
  },

  [types.SET_SOCKET](state, socket) {
    state.socket = socket;
    state.readyState = state.socket.readyState;
  },

  [types.SET_RECONNECTION](state, toggle) {
    state.reconnection = toggle;
  },

  [types.SET_RECONNECTION_TIMEOUT](state, id) {
    state.reconnectionTimeoutId = id;
  },

  [types.SET_CREDENTIALS](state, credentials) {
    if (credentials === null) {
      state.credentials = null;
      return;
    }
    state.credentials = {
      id: credentials.id,
      token: credentials.token,
      userId: credentials.userId,
    };
  },

  [types.SUSPEND_MESSAGE_UPDATE](state, toggle) {
    state.messageUpdateSuspended = toggle;
  },
};
